export const NAME = 'faq';

export const REQUEST_FAQ = 'REQUEST_FAQ';
export const RECEIVE_FAQ = 'RECEIVE_FAQ';
export const FAILURE_FAQ = 'FAILURE_FAQ';



// WEBPACK FOOTER //
// ./src/services/faq/constants.js